import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!token) {
      toast.error("Missing reset token");
      return;
    }
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (password !== confirm) {
      toast.error("Passwords don't match");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated. Please sign in.");
      nav("/auth");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset link is invalid or expired");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-12" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <p className="label-eyebrow mb-3">Account recovery</p>
        <h1 className="font-serif text-4xl mb-6 leading-tight">Choose a new password</h1>
        {!token ? (
          <div className="card-soft p-5">
            <p>This page needs a valid reset link. Request one from{" "}
              <Link to="/forgot-password" className="underline" style={{ color: "var(--brand)" }}>here</Link>.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input
              className="input-soft"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="New password (at least 6 characters)"
              minLength={6}
              required
              data-testid="reset-password-input"
            />
            <input
              className="input-soft"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Confirm new password"
              minLength={6}
              required
              data-testid="reset-confirm-input"
            />
            <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="reset-submit">
              {loading ? "Updating…" : "Update password"}
            </button>
          </form>
        )}
        <p className="mt-8 text-sm">
          <Link to="/auth" className="underline" style={{ color: "var(--brand)" }}>← Back to sign in</Link>
        </p>
      </div>
    </main>
  );
}
